<template>
  <div class="company">
    <div class="about">
      <div class="about-left">
        <h1>Profile</h1>
        <div>
          {{ $t("introduce.about") }}
        </div>
        <div>
          {{ $t("introduce.about2") }}
        </div>
        <h3>{{ $t("introduce.vision") }}</h3>
        <span>{{ $t("introduce.etao") }}</span>
      </div>
      <div class="about-right">
        <img src="../../assets/公司照片_slices/公司照片@2x.png" alt=""/>
      </div>
    </div>
    <div class="technology">
      <div class="technology-left">
        <h3>{{ $t("introduce.technology_title") }}</h3>
        <div>
          {{ $t("introduce.technology") }}
        </div>
        <div>
          {{ $t("introduce.invent") }}
        </div>
        <div>
          {{ $t("introduce.emis") }}
        </div>
      </div>
      <div class="technology-right">
        <!--        <img src="../../assets/image/company/core.svg" alt="" />-->
      </div>
    </div>
    <div class="line">
      <div class="course">
        <h3 class="course-title">{{ $t("introduce.course") }}</h3>
        <img src="../../assets/image/company/course.svg" alt=""/>
      </div>
    </div>
    <div class="certificate">
      <h3 class="title">{{ $t("introduce.certificate") }}</h3>
      <myCertificate></myCertificate>
    </div>
  </div>
</template>

<script>
import myCertificate from "@/components/carousel/myCertificate";

export default {
  components: {
    myCertificate
  }
};
</script>

<style scoped>
.company {
  padding-top: 80px;
}

.about {
  width: 100%;
  background-image: url("../../assets/image/company/vision.svg");
  background-size: cover;
  display: flex;
  justify-content: space-between;
}

.about-left {
  margin-top: 35px;
  flex: 1;
  margin-left: 150px;
}

.about-left > h1 {
  font-size: 90px;
  color: #121212;
  line-height: 120px;
  margin-bottom: 35px;
  position: relative;
}

.about-left h1:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 3px;
  width: 30px;
  background-color: red;
}

.about-left > div {
  color: #7e7e7c;
  line-height: 30px;
}

.about-left h3 {
  margin-top: 20px;
  position: relative;
  font-size: 24px;
  color: #121212;
  line-height: 45px;
}

.about-left > span {
  display: block;
  margin-top: 15px;
  margin-bottom: 50px;
  font-size: 15px;
  color: #7e7e7c;
  line-height: 40px;
}

.about-right > img {
  margin-left: 100px;
  margin-right: 150px;
  display: block;
  width: 500px;
  transform: translateY(50%);
}

/* 技术储备 */
.technology {
  width: 100%;
  height: 400px;
  background-color: #e5e5e5;
  display: flex;
  justify-content: center;
}

.technology > .technology-left {
  margin-left: 150px;
  margin-top: 30px;
}

.technology-left > h3 {
  margin-bottom: 30px;
  font-size: 24px;
  color: #121212;
  line-height: 45px;
  position: relative;
}

.technology-left > div {
  font-size: 14px;
  color: #7e7e7c;
  line-height: 28px;
}

.technology > .technology-right {
  flex: 1;
  margin: 0 150px;
}

.technology > .technology-right > img {
  display: block;
  width: 240px;
  height: 240px;
  margin-top: 80px;
}

/* 发展历程 */
.line {
  background-image: url("../../assets/image/line.png");
  background-size: cover;
  background-size: 100% 100%;
}

.course {
  margin-top: 60px;
  margin: 60px 150px;
}

.course > img {
  display: block;
  width: 100%;
  margin-top: 50px;
}

.course-title {
  width: 100%;
  height: 45px;
  position: relative;
  font-size: 24px;
  color: #121212;
  line-height: 45px;
}

.certificate {
  margin: 60px 0;
  padding: 0 150px;
  background-image: url("../../assets/image/product/back.png");
  background-size: cover;
  background-size: 100% 100%;
}

.title {
  margin: 50px 0;
  font-size: 24px;
  color: #121212;
  line-height: 45px;
  position: relative;
}

.certificate > img {
  width: 100%;
  padding-bottom: 100px;
}

/* 下边框 */
h3:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 3px;
  width: 20px;
  background-color: red;
}
</style>
